import { Link } from "react-router-dom";
import NewsletterForm from "@/components/feature/NewsletterForm";
import { primaryNav, secondaryNav } from "@/components/feature/navData";

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2.5" title="美日吃瓜 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-goblet-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-black text-background-50">美日吃瓜</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              聚焦娱乐圈的每日热点与幕后故事，用时间线和多视角复盘取代情绪化的围观。偶像塌房、演员绯闻、歌手翻车、综艺名场面，在这里看得更清楚一点。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="mailto:hello@meirichigua.com"
                rel="nofollow"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700/60 text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300"
                aria-label="邮件联系美日吃瓜"
                title="邮件联系美日吃瓜"
              >
                <i className="ri-mail-line" aria-hidden="true" />
              </a>
              <Link
                to="/about"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700/60 text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300"
                aria-label="关于美日吃瓜"
                title="关于美日吃瓜"
              >
                <i className="ri-information-line" aria-hidden="true" />
              </Link>
              <Link
                to="/faq"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700/60 text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300"
                aria-label="常见问题"
                title="常见问题"
              >
                <i className="ri-question-line" aria-hidden="true" />
              </Link>
            </div>
          </div>

          <nav className="lg:col-span-2" aria-label="频道导航">
            <h3 className="font-heading text-sm font-bold text-background-50">内容频道</h3>
            <ul className="mt-4 space-y-2.5">
              {primaryNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-2" aria-label="网站导航">
            <h3 className="font-heading text-sm font-bold text-background-50">网站</h3>
            <ul className="mt-4 space-y-2.5">
              {secondaryNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  每日热榜
                </Link>
              </li>
            </ul>
          </nav>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-sm font-bold text-background-50">每日热点订阅</h3>
            <p className="mt-3 text-sm leading-relaxed text-background-300">
              一个邮箱，收下当天最值得看的几条娱乐观察，不带节奏，只讲清楚。
            </p>
            <div className="mt-4">
              <NewsletterForm />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-800/70 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 美日吃瓜 · 娱乐向内容创作者，站内人物与事件均为化名与创作。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <a
              href="mailto:hello@meirichigua.com"
              rel="nofollow"
              className="transition-colors hover:text-accent-300"
            >
              hello@meirichigua.com
            </a>
            <span>每日更新 · 理性吃瓜</span>
          </p>
        </div>
      </div>
    </footer>
  );
}